import { Card, Space } from "@mantine/core";
import { useOutletContext } from "react-router-dom";
import CardPies from "@/modules/relatorio/components/card-bar";
import CardEmpresa from "@/modules/relatorio/components/card-empresa";
import AreaRelatorio from "@/modules/relatorio/components/graphics-nivo/AreaBarRelatorio";
import { TRelatorioContext } from "../RelatorioLayout";

const VisaoGeralTab = () => {
  const { empresas, values, setSelectedDate } = useOutletContext<TRelatorioContext>();

  return (
    <Card>
      <CardEmpresa empresas={empresas} questionario={values?.questionario} />
      <Space h={"xl"} />
      <AreaRelatorio empresas={empresas} onDateSelect={setSelectedDate} />
      <Space h={"xl"} />
      <CardPies empresas={empresas} />
    </Card>
  );
};

export default VisaoGeralTab;
